import { Component, EventEmitter, Output } from '@angular/core';
import { AppCommon } from './api-providers/app-common';
import { LoginViewModel } from './api-providers/view-models/login.view.model';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent {

  isCollapsed: boolean = true;
  isLoggedIn: boolean = false; 
  static staticCall: any;
  
  constructor() {
    AppComponent.staticCall = this;
    const loggedObject = AppCommon.getloggedInObject();
    const token = AppCommon.getloggedInObject()?.token;
    if (loggedObject && token){
      this.isLoggedIn = true
    }
    
  }

 


}
